import { extent as d3_extent } from 'd3-array'
import { convertRowsToData } from '../utils/dataUtils'

export default function LollipopBarChartDataController(rows, config = {}) {
  const propperHeaders = ['id', 'value', 'label', 'year']
  const dims = 1
  const data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)
  const extent = d3_extent(data, d => d.value)

  if (extent[0] > 0) extent[0] = 0
  let extentSize = Math.abs(extent[1] - extent[0])
  let getSafeValue = v => {
    return config.minBarHeight
      ? Math.sign(v) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
      : +v
  }

  function getLollipop(datum, i) {
    const headLen = propperHeaders.length
    return rows[i + 1].slice(headLen).map((d, j, v) => {
      return {
        id: rows[i + 1][0] + '-' + j,
        value: d,
        parent: datum.safeValue,
      }
    })
  }

  return data.map((d, i) => {
    if (!d.id) d.id = i
    d.safeValue = getSafeValue(d.value)
    d.lollipop = getLollipop(d, i)
    return d
  })
}
